import { useEffect } from "react";
import * as History from "../../../../common-deprecated/History";
import type { CarConfigDispatchType } from "../redux/store";
import { useCarConfigSelector } from "../redux/store";
import { queryStringToObject } from "../../../../common-deprecated/utils";
import { setNavigationStep } from "../redux/slices/CarConfigNavigationSlice";
import type { CarConfigStep } from "../../../../common-deprecated/features/apheleia/utils/carConfigNavigationUtils";
import { useDispatch } from "../../../../shared-logic/redux/store";

export const useAphNavigationListener = (): void => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const originalStep = useCarConfigSelector((state) => state.carConfigNavigation.step);
    const isRetailerToyota = useCarConfigSelector(
        (state) => state.commonSettings.query.retailerscreen && state.commonSettings.brand === "toyota",
    );

    // Does not need extra returns because cleanup is already taken care of
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (isRetailerToyota) {
            const unlisten = History.listen((event) => {
                const { path } = queryStringToObject(event.search);
                const step = path.split("/")[0] as CarConfigStep;
                // There are integrated URLs without the path query. If this check does not happen the carconfig is loaded without a path when the history changes
                if (step) {
                    if (originalStep !== step) dispatch(setNavigationStep(step));
                }
            });

            return () => {
                if (unlisten) unlisten();
            };
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, originalStep]);
};
